import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ChinaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14495'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14495)'>
				<rect
					width='20'
					height='14'
					fill='#F1361D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.19531 2.17048L7.88706 2.28605L8.40587 2.7491L8.5238 2.07119L8.9963 1.56275L8.30455 1.44718L7.78574 0.984131L7.66781 1.66204L7.19531 2.17048ZM9.04819 4.54157L9.64762 4.18405L10.3492 4.19995L9.98434 3.6125L10.0006 2.92499L9.40113 3.28252L8.69959 3.26661L9.06441 3.85406L9.04819 4.54157ZM8.23503 8.37956L7.64869 8.75737L7.64042 8.06972L7.2549 7.49511L7.95658 7.48701L8.54292 7.1092L8.55119 7.79684L8.93671 8.37146L8.23503 8.37956ZM8.74423 6.60195L9.44169 6.52619L10.0706 6.83116L9.99333 6.14765L10.3045 5.53128L9.60707 5.60704L8.97811 5.30207L9.05542 5.98558L8.74423 6.60195Z'
					fill='#FFDC42'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76144 5.7587L3.08205 6.93195L3.70169 5.00415L2.04414 3.80145L4.10648 3.78325L4.76144 1.8667L5.4164 3.78325L7.47874 3.80145L5.82119 5.00415L6.44083 6.93195L4.76144 5.7587Z'
					fill='#FFDC42'
				/>
			</g>
		</svg>
	);
};

export default ChinaFlagIcon;
